import { useState, useEffect, useCallback } from "react";
import { PurchaseOrder } from "@po-management/types";
import { useApiClient } from "../../auth/useApiClient";

export function usePO(id: string | undefined): { po: PurchaseOrder | null; loading: boolean; error: string | null; refetch: () => void } {
  const [po, setPo] = useState<PurchaseOrder | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { get } = useApiClient();

  const fetch = useCallback((): void => {
    if (!id) return;
    setLoading(true);
    setError(null);
    get(`/api/pos/${id}`)
      .then((r) => r.json())
      .then((body: { success: boolean; data: PurchaseOrder }) => {
        if (body.success) setPo(body.data);
        else setError("Failed to load PO");
      })
      .catch(() => setError("Failed to load PO"))
      .finally(() => setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => { fetch(); }, [fetch]);

  return { po, loading, error, refetch: fetch };
}
